import { isProd } from "./api-const";

export const FEATURE_FLAGS = {
  ENABLE_WALKTHROUGH: false,
  ENABLE_PREFERENCE: !isProd,
  ENABLE_FAQ: !isProd,
  ENABLE_WISHLIST: true,
  ENABLE_CLARITY: false,
  ENABLE_OTHERS: true,
};
